<template>
  <div class="relative mx-4 mt-4">
    <div class="flex">
      <div class="basis-1/4">
        <div class="flex">
          <button
            class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded text-center whitespace-nowrap mr-2"
            @click.prevent="processGenerateInvoice"
            v-show="isAnySpeakerBooked"
          >
            Generate Invoices
          </button>
          <button
            class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded text-center whitespace-nowrap"
            @click.prevent="processGeneratePO"
            v-show="isAnySpeakerBooked"
          >
            Generate PO
          </button>
        </div>
      </div>
      <div class="basis-3/4">
        <div class="flex justify-end">
          <button
            class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded"
            @click.prevent="openFilterShortlistedSpeakers = true"
          >
            Search Speakers
          </button>
          <button
            class="bg-transparent hover:bg-yellow-500 text-yellow-700 font-semibold hover:text-white py-2 px-4 border border-yellow-500 hover:border-transparent rounded ml-2 mr-2"
            @click="openRearrangeSpeakersModal = true">
            Rearrange
          </button>
          <button
            class="bg-transparent hover:bg-red-500 text-red-700 font-semibold hover:text-white py-2 px-4 border border-red-500 hover:border-transparent rounded mr-2"
            @click="openRejectAllModal = true">
            Reject All
          </button>
          <button
            class="bg-transparent hover:bg-gray-500 text-gray-700 font-semibold hover:text-white py-2 px-4 border border-gray-500 hover:border-transparent rounded mr-2"
            @click="openViewRejectedSpeakersModal = true">
            View Rejected
          </button>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <div class="flex mt-4">
        <table
          class="table-auto w-72 overflow-x-auto border-2 text-sm text-left text-gray-500 dark:text-gray-400"
        >
          <thead
            id="shortlisted-speakers-table-head"
            class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400"
          >
            <tr>
              <th scope="col" class="px-6 py-3 text-center">No</th>
              <th scope="col" class="text-center px-6 py-3" colspan="2">Actions</th>
              <th scope="col" class="px-6 py-3 text-center sticky left-0 bg-gray-50 dark:bg-gray-700">Speaker Name</th>
              <th scope="col" class="px-6 py-3 text-center">Shortlist</th>
              <th scope="col" class="px-6 py-3 text-center w-40">Status</th>
              <th scope="col" class="px-6 py-3 text-center"></th>
              <th scope="col" class="px-6 py-3 text-center">Commission</th>
              <th scope="col" class="px-6 py-3 text-center">Exclusivity</th>
              <th scope="col" class="px-6 py-3 text-center">Live Keynote Fee</th>
              <th scope="col" class="px-6 py-3">In Conversation Fee</th>
              <th scope="col" class="px-6 py-3">Virtual/Pre-recorded Fee</th>
              <th scope="col" class="px-6 py-3">Full Day Workshop Fee</th>
              <th scope="col" class="px-6 py-3">Half Day Workshop Fee</th>
              <th scope="col" class="px-6 py-3">MC Half Day Fee</th>
              <th scope="col" class="px-6 py-3">MC Full Day Fee</th>
              <th scope="col" class="px-6 py-3">Education/NFP Fee</th>
              <th scope="col" class="px-6 py-3">Campaign Fee</th>
              <th scope="col" class="px-6 py-3">Other Fee</th>
              <th scope="col" class="px-6 py-3">Account Name</th>
              <th scope="col" class="px-6 py-3">Contact Name</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="shortlistedSpeakerList.length > 0">
              <template v-for="(speakers, category) in speakersGroupedByCategory" :key="category">
                <tr class="bg-gray-200 dark:bg-gray-600">
                  <!-- Category Headers -->
                  <td 
                    v-if="category != 'No Category' || (category === 'No Category' && speakers.length > 0)"
                    colspan="21" 
                    class="px-5 py-3 font-bold text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-700"
                  >
                    <div class="flex items-center">
                      <span>{{ category }}</span>
                      <i
                        v-if="category != 'No Category'" 
                        @click="openEditCategoryModal(category)"
                        class="ml-4 text-black dark:text-gray-300 fill-current cursor-pointer fas fa-pen text-base">
                      </i>
                    </div>
                  </td>
                </tr>
                <tr
                  v-for="(speaker, index) in speakers"
                  :key="speaker.id"
                  class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
                >
                  <td class="px-6 py-4">
                    {{ speaker.fees.Order }}
                  </td>
                  <td class="px-6 py-4">
                    <div class="flex gap-x-4 items-center">
                      <div class="flex-auto">
                        <a
                          :href="
                            shortlistedSpeakerFeesBaseUrl +
                            speaker.fees.id +
                            '/edit'
                          "
                          target="_blank"
                          v-show="speaker.fees.id"
                        >
                          <i 
                            class="text-black dark:text-gray-300 fill-current fas fa-pen text-2xl">
                          </i>
                        </a>
                      </div>
                      <div class="flex-auto">
                        <i
                          @click="showRemoveSpeakerModal(speaker)" 
                          class="text-black dark:text-gray-300 fill-current cursor-pointer fas fa-user-xmark text-2xl">
                        </i>
                      </div>
                    </div>
                  </td>
                  <td class="px-6 py-4">
                    <div class="flex-auto">
                      <button
                        :class="[
                          'px-4 py-1 text-gray-700 ring-1 ring-inset ring-gray-700 rounded-md',
                          speaker.file_generated == true
                            ? 'bg-green-500'
                            : 'bg-white',
                        ]"
                        @click="generateFile(speaker)"
                        v-if="speaker.fees.Status == 'Booked'"
                      >
                        {{
                          speaker.file_generated == true
                            ? "Generated"
                            : "Generate"
                        }}
                      </button>
                    </div>
                  </td>
                  <th
                    scope="row"
                    class="text-center px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap sticky left-0 bg-inherit z-1"
                  >
                    <el-popover
                      placement="right"
                      :width="500"
                      trigger="hover"
                      :show-after="500"
                    >
                      <template #reference>
                        <a
                          :href="
                            speaker_crm_url +
                            speaker.speaker.crm_id
                          "
                          class="text-blue-500"
                          target="_blank"
                          @mouseover="onHover(speaker.speaker.crm_id)"
                          >{{ speaker.speaker.speaker_name }}
                        </a>
                      </template>
                      <el-descriptions
                        :title="speaker.speaker.speaker_name"
                        :column="1"
                        :size="size"
                        direction="horizontal"
                        :style="blockMargin"
                      >
                        <el-descriptions-item label="City">{{
                          speakerFeeData.City
                        }}</el-descriptions-item>
                        <el-descriptions-item label="Live Keynote Fee">{{
                          speakerFeeData.Live_Keynote_Fee
                        }}</el-descriptions-item>
                        <el-descriptions-item label="In Conversation Fee">{{
                          speakerFeeData.In_Conversation_Fee
                        }}</el-descriptions-item>
                        <el-descriptions-item label="Virtual Keynote Fee">{{
                          speakerFeeData.Virtual_Keynote_Fee
                        }}</el-descriptions-item>
                        <el-descriptions-item label="Full Day Workshop Fee">{{
                          speakerFeeData.Live_Workshop_Fee
                        }}</el-descriptions-item>
                        <el-descriptions-item label="Half Day Workshop Fee">{{
                          speakerFeeData.Half_Day_Workshop_Fee
                        }}</el-descriptions-item>
                        <el-descriptions-item label="MC Half Day Fee">{{
                          speakerFeeData.MC_Rate
                        }}</el-descriptions-item>
                        <el-descriptions-item label="MC Full Day Fee">{{
                          speakerFeeData.MC_Full_Day
                        }}</el-descriptions-item>
                        <el-descriptions-item label="Campaign Fee">{{
                          speakerFeeData.Campaign_Fee
                        }}</el-descriptions-item>
                        <el-descriptions-item label="Other Fee">{{
                          speakerFeeData.Other_Fee
                        }}</el-descriptions-item>
                        <el-descriptions-item label="Education/NFP Fee">{{
                          speakerFeeData.Education_NFP_Fee
                        }}</el-descriptions-item>
                        <el-descriptions-item label="Gross Fees Range">{{
                          speakerFeeData.Gross_Fees_Range
                        }}</el-descriptions-item>                               
                      </el-descriptions>
                    </el-popover>
                  </th>
                  <th
                    scope="row"
                    class="text-center px-6 py-4 font-medium text-gray-900 dark:text-white whitespace-nowrap"
                  >
                    <a
                      :href="
                        shortlisted_speaker_crm_url +
                        speaker.shortlisted_speaker_crm_id
                      "
                      class="text-blue-500"
                      target="_blank"
                      v-show="speaker.shortlisted_speaker_name"
                      >{{ speaker.shortlisted_speaker_name }}
                    </a>
                  </th>
                  <td class="px-6 py-4">
                    <div class="relative text-center whitespace-nowrap w-32">
                      <select
                        @change="(event) => selectOption(event, speaker)"
                        :class="[
                          'block appearance-none w-full border border-gray-200 text-gray-700 py-1 px-2 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500',
                          'status-' + speaker.fees.id,
                        ]"
                        id="grid-state"
                      >
                        <option
                          v-for="(option, index) in statusOptions"
                          :selected="
                            speaker.fees.Status == option.label ? 'selected' : null
                          "
                          :value="option.id"
                          :key="index"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>
                    </div>
                  </td>

                  <td class="px-6 py-4">
                    <span :class="changeColor(speaker.fees.Status)">
                      {{ speaker.fees.Status }}
                    </span>
                  </td>

                  <td class="px-6 py-4">
                    <div
                      class="flex gap-x-2"
                      v-if="speaker.shortlisted_speaker_crm_id"
                    >
                      <div class="flex-auto w-28">
                        <jet-input
                          :style="`px-1 py-2 text-xs`"
                          @keyup="showCommissionTick"
                          :id="'commission-' + speaker.fees.id"
                          class="py-2 px-2 rounded"
                          :value="
                            getCommissionAmount(speaker.fees.id)
                          "
                        />
                      
                        
                      </div>
                      <div class="relative flex-auto w-28">
                        <select
                        @change="(event) => commissionTypeSelected(event, speaker)"
                        :class="[
                          'block appearance-none w-full border border-gray-200 text-gray-700 py-2.5 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500',
                        ]"
                        :id="'commission-type-'+speaker.fees.id"
                      >
                        <option
                          v-for="(option, index) in commissionType"
                          :selected="
                            isCommissionType(speaker.fees.id, option.id) ? 'selected' : null
                          "
                          :value="option.id"
                          :key="index"
                        >
                          {{ option.label }}
                        </option>
                      </select>
                      <div
                        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                      >
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path
                            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                          />
                        </svg>
                      </div>

                        
                      </div>

                      <div
                        class="flex-auto py-2"
                        :class="[
                          'showTick-' + speaker.fees.id,
                        ]"
                        hidden
                      >
                        <a
                          @click="
                            updateCommission(speaker.fees.id)
                          "
                          href="javascript:void(0)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24px"
                            height="24px"
                          >
                            <path
                              d="M 20.292969 5.2929688 L 9 16.585938 L 4.7070312 12.292969 L 3.2929688 13.707031 L 9 19.414062 L 21.707031 6.7070312 L 20.292969 5.2929688 z"
                            />
                          </svg>
                          <!-- <font-awesome-icon icon="fa-solid fa-check"
                        /> -->
                        </a>
                      </div>
                    </div>
                  </td>

                  <td class="text-center px-6 py-4">
                    {{ speaker.speaker.exclusivity }}
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_LKF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'Live_Keynote_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_LKF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_LKF_to_Qwilr')"         
                              :id="'Live_Keynote_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"Live_Keynote_Fee")'
                            />
                        </div>
                        <div :class="['py-1','Live_Keynote_Fee-' + speaker.fees.id,'Allow_LKF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'Live_Keynote_Fee','Allow_LKF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_ICF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'In_Conversation_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_ICF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_ICF_to_Qwilr')"         
                              :id="'In_Conversation_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"In_Conversation_Fee")'
                            />
                        </div>
                        <div :class="['py-1','In_Conversation_Fee-' + speaker.fees.id,'Allow_ICF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'In_Conversation_Fee','Allow_ICF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_VKFL_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'Virtual_Keynote_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_VKFL_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_VKFL_to_Qwilr')"
                              :id="'Virtual_Keynote_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"Virtual_Keynote_Fee")'
                            />
                        </div>
                        <div :class="['py-1','Virtual_Keynote_Fee-' + speaker.fees.id,'Allow_VKFL_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'Virtual_Keynote_Fee','Allow_VKFL_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_FDWF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'Full_Day_Workshop_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_FDWF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_FDWF_to_Qwilr')"
                              :id="'Full_Day_Workshop_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"Full_Day_Workshop_Fee")'
                            />
                        </div>
                        <div :class="['py-1','Full_Day_Workshop_Fee-' + speaker.fees.id,'Allow_FDWF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'Full_Day_Workshop_Fee','Allow_FDWF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_HDWF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'Half_Day_Workshop_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_HDWF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_HDWF_to_Qwilr')"
                              :id="'Half_Day_Workshop_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"Half_Day_Workshop_Fee")'
                            />
                        </div>
                        <div :class="['py-1','Half_Day_Workshop_Fee-' + speaker.fees.id,'Allow_HDWF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'Half_Day_Workshop_Fee','Allow_HDWF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_MCHDF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'MC_Half_Day_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_MCHDF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_MCHDF_to_Qwilr')"
                              :id="'MC_Half_Day_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"MC_Half_Day_Fee")'
                            />
                        </div>
                        <div :class="['py-1','MC_Half_Day_Fee-' + speaker.fees.id,'Allow_MCHDF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'MC_Half_Day_Fee','Allow_MCHDF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_MCFDF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'MC_Full_Day_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_MCFDF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_MCFDF_to_Qwilr')"
                              :id="'MC_Full_Day_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"MC_Full_Day_Fee")'
                            />
                        </div>
                        <div :class="['py-1','MC_Full_Day_Fee-' + speaker.fees.id,'Allow_MCFDF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'MC_Full_Day_Fee','Allow_MCFDF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_ENF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'Education_NFP_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_ENF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_ENF_to_Qwilr')"
                              :id="'Education_NFP_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"Education_NFP_Fee")'
                            />
                        </div>
                        <div :class="['py-1','Education_NFP_Fee-' + speaker.fees.id,'Allow_ENF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'Education_NFP_Fee','Allow_ENF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_CF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'Campaign_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_CF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_CF_to_Qwilr')"
                              :id="'Campaign_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"Campaign_Fee")'
                            />
                        </div>
                        <div :class="['py-1','Campaign_Fee-' + speaker.fees.id,'Allow_CF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'Campaign_Fee','Allow_CF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    <div v-if="speaker.shortlisted_speaker_crm_id">
                      <div class="flex flex-row gap-4">
                        <div class="py-3">
                          <input
                            :id="'Allow_OF_to_Qwilr-' + speaker.fees.id"
                            type="checkbox"
                            @change="keyNoteValueChangeHandle($event,'Other_Fee')"
                            :checked="getAllowedCheckboxVal(speaker.fees.id,'Allow_OF_to_Qwilr')"
                            class="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
                          />
                        </div>
                        <div>
                          <jet-input
                              :style="`px-1 py-2 text-xs`"
                              @keyup="keyNoteValueChangeHandle($event,'Allow_OF_to_Qwilr')"
                              :id="'Other_Fee-' + speaker.fees.id"
                              class="py-2 px-2 rounded w-20"
                              :value='getFeeAmount(speaker.fees.id,"Other_Fee")'
                            />
                        </div>
                        <div :class="['py-1','Other_Fee-' + speaker.fees.id,'Allow_OF_to_Qwilr-' + speaker.fees.id]" hidden>
                          <button
                            @click="updateFeeAmount(speaker.fees.id,'Other_Fee','Allow_OF_to_Qwilr')"
                            class="inline-flex items-center px-4 py-1 text-sm font-semibold text-white bg-blue-500 shadow leading-6 rounded-md hover:bg-blue-600 transition ease-in-out duration-150">
                            Update
                          </button>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="text-center px-6 py-4">
                    {{ speaker.speaker.account_name }}
                  </td>
                  <td class="text-center px-6 py-4">
                    {{ speaker.contact_name }}
                  </td>
                </tr>
              </template>
            </template>
            <tr v-else>
              <td colspan="21" class="text-center text-gray-700">
                No Data Available!
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- App Version -->
    <div class="text-[12px] italic text-gray-600 m-2">v2026.2.17.1</div>

    <GenerateInvoice
      :dealInfo="dealInfo"
      :shortlistedSpeakerList="shortlistedSpeakerList"
      :shortListedSpeakersInfo="shortListedSpeakersInfo"
      :calculatedBill="calculatedBill"
      v-model:invoiceLoaded="invoiceLoaded"
      v-model:is-visible="openGenerateInvoice"
    />
    <GeneratePO
      :dealInfo="dealInfo"
      :shortListedSpeakersInfo="allShortlistedPOInfo"
      v-model:is-visible="openGeneratePO"
    />
    <FilterShortlistedSpeakers
      :dealInfo="dealInfo"
      :speakerList="speakerList"
      :shortlistedSpeakerCategories="shortlistedSpeakerCategories"
      :shortlistedSpeakerList="shortlistedSpeakerList"
      :speakerPicklists="speakerPicklists"
      v-model:is-visible="openFilterShortlistedSpeakers"
      @addNewCategory="addNewCategory"
    />
    <GenerateFile
      :dealInfo="dealInfo"
      v-model:is-visible="openGenerateFileModal"
    />
    <div
      v-if="showLoadingScreen"
      class="fixed z-10 top-0 left-0 flex items-center justify-center w-screen h-screen bg-slate-300"
    >
      <loading>{{ loadingText }}</loading>
    </div>
    <div
      v-if="loading"
      class="fixed z-10 top-0 left-0 flex items-center justify-center w-screen h-screen"
    >
      <loading paddingClass="px-3 py-1" bgColorClass="bg-gray-400">
        {{ loadingText }}
      </loading>
    </div>
  </div>

  <div
    class="fixed z-10 top-0 left-0 flex items-center justify-center w-screen h-screen bg-gray-600/50 transition-all ease-in duration-75"
    :class="{
      'opacity-0 invisible pointer-events-none scale-75': !showPopUpModal,
    }"
  >
    <div class="px-10 py-5 bg-white rounded-lg ring-2 w-auto">
      <div
        class="flex items-center text-blue-500 mt-2 mb-4 ml-2"
        style="white-space: pre"
      >
        {{ message }}
      </div>
      <div class="flex justify-center mt-2">
        <button
          @click="showPopUpModal = false"
          class="w-1/4 px-4 text-sm font-semibold text-white bg-gray-500 border-2 border-green-500 shadow leading-6 rounded-md transition ease-in-out duration-150"
        >
          Ok
        </button>
      </div>
    </div>
  </div>
  <div
    class="fixed z-10 top-0 left-0 flex items-center justify-center w-screen h-screen bg-gray-600/50 transition-all ease-in duration-75"
    :class="{
      'opacity-0 invisible pointer-events-none scale-75': !showHeldPopUpModal,
    }"
  >
    <div class="px-10 py-5 bg-white rounded-lg ring-2 w-100 max-h-[90vh] overflow-y-auto">
      <div class="grid grid-cols-2 gap-4 py-2">
        <div class="items-end text-blue-500 pt-2">
          {{ isBookedPopUp ? "Book Date Range:" : "Hold Date Range:" }}
        </div>
        <div class="items-center">
          <date-time-input
            v-model="eventDateTime"
            teleport-center
            format="dd/MM/yyyy HH:mm"
            range :partial-range="false"
          ></date-time-input>
        </div>     
      </div>
      <div v-for="(additionalDate, index) in additionalDates">
        <div class="grid grid-cols-2 gap-4 py-2" >
          
              <div class="items-end text-blue-500 pt-2">
                Additional Date Range:
              </div>
              <div class="items-center">
                <date-time-input
                  v-model="additionalDate.date_time"
                  teleport-center
                  format="dd/MM/yyyy HH:mm"
                  range :partial-range="false"
                ></date-time-input>
              </div>
        </div>
      </div>
      <div
        class="items-start text-red-500 mt-2 mb-4 ml-2 py-4"
        v-if="notDateFound"
      >
        <span>Please select your desire date range.</span>
      </div>
      <div class="flex justify-center mt-2 gap-4 py-4">
        <button
          @click="addMore"
          class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-1 px-2 border border-blue-500 hover:border-transparent rounded text-center whitespace-nowrap"
        >
          Add More
        </button>
        <button
          @click="updateStatus"
          class="w-1/4 px-4 text-sm font-semibold text-white bg-blue-500 border-2 shadow leading-6 rounded-md transition ease-in-out duration-150"
        >
          Update
        </button>
        <button
          @click="cancelUpdateStatus"
          class="w-1/4 px-4 text-sm font-semibold text-white bg-red-500 border-2 shadow leading-6 rounded-md transition ease-in-out duration-150"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>

  <RearrangeSpeakersModal
    :isVisible="openRearrangeSpeakersModal"
    :speakersGroupedByCategory="speakersGroupedByCategory"
    @save="rearrangeSpeakers"
    @update:isVisible="openRearrangeSpeakersModal = false"
  />

  <RejectAllSpeakersModal
    v-model:isVisible="openRejectAllModal"
    @confirm="rejectAllSpeakers"
  />

  <RemoveSpeakerModal 
    v-model:isVisible="openRemoveSpeakerModal"
    :speaker="speakerToRemove"
    @confirm="removeSpeakerRow"
    @cancel="openRemoveSpeakerModal = false"
  />

  <ViewRejectedSpeakersModal
    :isVisible="openViewRejectedSpeakersModal"
    :rejectedSpeakers="rejectedSpeakers"
    @update:isVisible="openViewRejectedSpeakersModal = false"
  />

  <EditCategoryModal
    :visible="showEditCategoryModal"
    :originalCategory="categoryToUpdate"
    @close="closeEditCategoryModal"
    @save="saveEditedCategory"
  />

  <SaveModal v-if="saving" />

</template>

<script>
import GenerateInvoice from '@/views/Shortlisted-Speakers/GenerateInvoice';
import GeneratePO from '@/views/Shortlisted-Speakers/GeneratePO';
import FilterShortlistedSpeakers from '@/views/Shortlisted-Speakers/FilterShortlistedSpeakers';
import ViewRejectedSpeakersModal from '@/components/modals/ViewRejectedSpeakersModal.vue';
import RejectAllSpeakersModal from '@/components/modals/RejectAllSpeakersModal.vue';
import EditCategoryModal from '@/components/modals/EditCategoryModal.vue';
import SaveModal from '@/components/SaveModal.vue';
import RearrangeSpeakersModal from '@/components/modals/RearrangeSpeakersModal.vue';
import RemoveSpeakerModal from '@/components/modals/RemoveSpeakerModal.vue';
import {
  fetchShortlistedSpeakers,
  updateShortlistedSpeaker,
  generateFile,
  syncShortlistedSpeaker,
  noAssignSpeaker
} from '@/services/ShortlistedSpeakerService';
import { getLocalISOTime } from '@/utils';
import JetInput from '@/components/JetInput';
import AppSelect from '@/components/AppSelect';
import Loading from '@/components/Loading';
import GenerateFile from '@/components/GenerateFile';
import DateTimeInput from '@/components/DateTimePicker.vue';
import { ElMessage, ElMessageBox } from 'element-plus';

export default {
  name: 'pages.shortlisted-speakers.widget',
  components: {
    GenerateInvoice,
    GeneratePO,
    FilterShortlistedSpeakers,
    JetInput,
    AppSelect,
    Loading,
    GenerateFile,
    DateTimeInput,
    RejectAllSpeakersModal,
    ViewRejectedSpeakersModal,
    EditCategoryModal,
    SaveModal,
    RearrangeSpeakersModal,
    RemoveSpeakerModal
  },
  data: () => ({
    openFilterShortlistedSpeakers: false,
    openGenerateInvoice: false,
    openGeneratePO: false,
    openRejectAllModal: false,
    openRemoveSpeakerModal: false,
    isAnySpeakerBooked: false,
    showHeldPopUpModal: false,
    eventEndDateVal: null,
    eventDateTime: null,
    isBookedPopUp: false,
    invoiceLoaded: false,
    updateStatusData: {},
    notDateFound: false,
    additionalDates: [],
    dealInfo: {
      deal_id: null,
      name: null,
      function_date: null,
      additionalFunctionDatesSubform: null,
      client_name: null,
      booking_number: null,
      acc_id: null,
      contactId: null,
      currency: null,
    },
    commissionType:[ { id: '%', label: 'Percent' },
      { id: '$', label: 'Dollar' }],
    emails: [],
    testing: null,
    again: null,
    speakerList: [],
    shortlistedSpeakerList: [],
    shortListedSpeakersInfo: [],
    allShortlistedPOInfo: [],
    allShortlistedSpeakerInfo: [],
    calculatedBill: 0,
    statusOptions: [
      { id: '-None-', label: '-None-' },
      { id: 'Held', label: 'Held' },
      { id: 'Booked', label: 'Booked' },
      { id: 'Released', label: 'Released' },
      { id: 'Postponed', label: 'Postponed' },
      { id: 'Rejected', label: 'Rejected' },
      { id: 'Cancelled', label: 'Cancelled' },
      { id: 'Unavailable', label: 'Unavailable' },
    ],
    selectedValue: null,
    loadingText: 'Please Wait...',
    showLoadingScreen: false,
    openGenerateFileModal: false,
    loading: false,
    showPopUpModal: false,
    message: null,
    commission: null,
    showTick: false,
    speakerFeeData: {},
    blockMargin: '32px',
    size: 'small',
    shortlisted_speaker_crm_url: process.env.VUE_APP_SHS_CRM_URL,
    shortlistedSpeakerFeesBaseUrl: process.env.VUE_APP_CRM_FEES_MODULE_URL,
    speaker_crm_url: process.env.VUE_APP_SPEAKER_CRM_URL,
    // Rejected Speakers
    openViewRejectedSpeakersModal: false,
    rejectedSpeakers: [],
    // Global Picklist Categories
    globalPicklistCategories: [],
    shortlistedSpeakerCategories: [],
    shortlistedSpeakerCategoriesOrder: [],
    // Edit Category
    showEditCategoryModal: false,
    categoryToUpdate: null,
    // Save Modal
    saving: false,
    // Rearrange Speakers
    openRearrangeSpeakersModal: false,
    // Represents the picklists in the 'FilterShortlistedSpeakers' component.
    // Keys need to be the API names of the picklist fields in the 'Speakers' module.
    speakerPicklists: {
      'Gender': [],
      'Exclusivity': [],
      'State': [],
      'Gross_Fees_Range': [],
      'Categories': [],
      'Keywords': [],
      'Expertise': []
    },
  }),
  computed: {
    speakersGroupedByCategory() {
      // The 'reduce' method will group speakers by their category.
      // 'groups' stores the list of grouped speakers.
      // 'speaker' is the current speaker being processed.
      const grouped = this.shortlistedSpeakerList.reduce((groups, speaker) => {
        const category = speaker.fees?.Category || 'No Category';

        // Check if the category already exists. If not, initialise.
        if (!groups[category]) {
          groups[category] = [];
        }

        groups[category].push(speaker);

        // Return the list as we build it out so the next iteration can add onto it.
        return groups;
      }, {});

      // Ensure 'No Category' always exists, even if it's empty.
      if (!grouped['No Category']) {
        grouped['No Category'] = [];
      }

      // Use the saved order of categories, falling back to alphabetical order if not set.
      const categories = this.shortlistedSpeakerCategoriesOrder.length
        ? [...this.shortlistedSpeakerCategoriesOrder]
        : Object.keys(grouped).filter((category) => category !== 'No Category').sort();

      // Add 'No Category' to the end of the list if it's not already included.
      const hasNoCategorySpeakers = this.shortlistedSpeakerList.some(
        (speaker) => !speaker.fees?.Category
      );

      if (hasNoCategorySpeakers && !categories.includes('No Category')) {
        categories.push('No Category');
      }

      // Rebuild the grouped object in the desired order.
      return categories.reduce((sortedGroups, category) => {

        // Ensure the category exists in the grouped object.
        if (!grouped[category]) {
          grouped[category] = [];
        }

        // Sort speakers within each category by their `Order` field.
        sortedGroups[category] = grouped[category].sort((a, b) => {
          return (a.fees.Order || 0) - (b.fees.Order || 0);
        });

        return sortedGroups;
      }, {});
    },
  },
  async mounted() {
    await this.init();
    document.querySelector('.home-menu');
  },

  /* global ZOHO */
  methods: {
    async init() {
      this.showLoadingScreen = true;
      ZOHO.embeddedApp.on('PageLoad', async (data) => {
        let entityId = data.EntityId;

        // Syncs the 'Deals X Shortlisted' records with the database. Ensures that any new records
        // created since the last time the records were loaded via the widget have been synced with
        // the server and database.
        await this.syncShortlistedSpeaker(entityId);

        // Fetch the Opportunity data.
        await ZOHO.CRM.API.getRecord({
          Entity: data.Entity,
          RecordID: data.EntityId,
        }).then(async (response) => {
          let data = response.data[0];

          // Populate the 'deal_info' object with the relevant data from the Opportunity record.
          this.updatedDealFields(data);

          if (this.dealInfo.client_name === undefined) {
            this.loadingText = 'Please assign a contact.';
            this.showPopUpNotification('Contact Not Assigned');
            return false;
          }

          // Fetch the shortlisted speakers (and fee records) for the Opportunity.
          await this.fetchShortlistedSpeaker(data.id);

          // Retrieve the saved order of categories from the 'Shortlisted Speaker Categories' field.
          let savedCategories = data.Shortlisted_Speaker_Categories
          ? data.Shortlisted_Speaker_Categories.split('|||').map((category) => category.trim())
          : [];

          // Cross-reference the saved categories with the shortlistedSpeakerList categories.
          // This ensures that only categories that are actually used by the shortlisted speakers
          // are included in the list.
          const activeCategories = this.shortlistedSpeakerList
            .map((speaker) => speaker.fees?.Category)
            .filter((category) => category !== null);

          // Filter the saved categories to include only those that have speakers assigned.
          this.shortlistedSpeakerCategoriesOrder = savedCategories.filter((category) =>
            activeCategories.includes(category)
          );

          // Sum all fees for each shortlisted speaker. This gets used later when generating Invoices
          // and Purchase Orders.
          this.shortListedspeakersBill();

          // Get the global picklist values for the categories that can be used in the widget.
          this.fetchCategoriesGlobalPicklistFromCRM();

          // Get the picklist values for the 'Speakers' module.
          // These values get used in the 'FilterShortlistedSpeakers' component, when users are searching for
          // Speakers to add to the widget.
          await this.getPicklistValuesFromCRM('Speakers',this.speakerPicklists);

          // Manually sort the Expertise list alphabetically - there is a bug in the Fetch Picklists API where the 
          // sequence_number doesn't respect the order of the saved fields in the module settings. Ticket #9930 has
          // more info. Easier to sort alphabetically for now as Saxton is happy with that at least.
          this.speakerPicklists.Expertise.sort();
        });
      });
      ZOHO.embeddedApp.init();
      this.loading = false;
    },
    async processGenerateInvoice() {
      if (this.dealInfo.deal_id) {
        this.showLoadingScreen = true;
        const recordDetails = await ZOHO.CRM.API.getRecord({
          Entity: 'Deals',
          RecordID: this.dealInfo.deal_id,
        });
        let dealInfo = recordDetails.data[0];
        let error_notification = '';
        
        // Certain values for this picklist are allowed to have a null function date.
        let saxtonOrOther = dealInfo.Saxton_or_CSNZ;
        var nullFunctionDateAllowed = ['Engage', 'Voiceover', 'Power Pets'];

        if (dealInfo.Function_Date == null && !nullFunctionDateAllowed.includes(saxtonOrOther)) {
          this.showLoadingScreen = false;
          this.showPopUpNotification(
            'Function Date is null. Please set a function date.'
          );
          return false;
        }
        this.updatedDealFields(dealInfo);
        await this.shortListedspeakersBill();
        const noAmountSpeakerList = this.shortListedSpeakersInfo.filter(
          (speaker) => speaker.listprice == 0
        );
        noAmountSpeakerList.forEach((speaker_details) => {
          error_notification += speaker_details.speaker.speaker_name + `'s amount is empty. \n`;
        });
        if (this.shortListedSpeakersInfo.length == 0) {
          this.showLoadingScreen = false;
          this.showPopUpNotification('The invoices for all shortlisted speakers have been generated.');
          return false;
        }
        if (error_notification) {
          this.showLoadingScreen = false;
          this.showPopUpNotification(error_notification);
          return false;
        }
        

        this.invoiceLoaded = false;
        this.openGenerateInvoice = true;
      }
    },
    updatedDealFields(data) {
      this.dealInfo.deal_id = data.id;
      this.dealInfo.name = data.Deal_Name;
      this.dealInfo.function_date = data.Function_Date
        ? data.Function_Date
        : getLocalISOTime(new Date().toISOString());
      this.dealInfo.client_name = data.Contact_Name?.name;
      this.dealInfo.contactId = data.Contact_Name?.id;
      this.dealInfo.booking_number = data.Enquiry_Booking_Number;
      this.dealInfo.acc_id = data.Account_Name?.id;
      this.dealInfo.inv_status = data.Invoice_Status;
      this.dealInfo.saxton_or_csnz = data.Saxton_or_CSNZ;
      this.dealInfo.consultant = data.Consultant?.name;
      this.dealInfo.co_ordinator = data.Co_Ordinator?.name;
      this.dealInfo.currency = data.Currency;
      this.dealInfo.additionalFunctionDatesSubform = data.Additional_Functions;
    },
    async processGeneratePO() {
      if (this.dealInfo.deal_id) {
        this.showLoadingScreen = true;
        const recordDetails = await ZOHO.CRM.API.getRecord({
          Entity: 'Deals',
          RecordID: this.dealInfo.deal_id,
        });
        let dealInfo = recordDetails.data[0];
        let error_notification = '';

        if (dealInfo.Invoice_Status != 'Created') {
          this.showLoadingScreen = false;
          this.showPopUpNotification('Invoice is not created.');
          return false;
        }

        this.updatedDealFields(dealInfo);

        await this.shortListedspeakersBill();

        if (this.allShortlistedPOInfo.length == 0) {
          this.showLoadingScreen = false;
          this.showPopUpNotification('The Purchase Order for all shortlisted speakers have been generated.');
          return false;
        }

        const noAmountSpeakerList = this.allShortlistedPOInfo.filter(
          (speaker) => speaker.listprice == 0 || speaker.fees.Commission == null
        );
        noAmountSpeakerList.forEach((speaker_details) => {
          error_notification +=
            speaker_details.speaker.speaker_name + `'s amount/commission is empty. \n`;
        });
        if (error_notification) {
          this.showLoadingScreen = false;
          this.showPopUpNotification(error_notification);
          return false;
        }
        this.openGeneratePO = true;
      }
    },
    showPopUpNotification(msg) {
      this.message = msg;
      this.showPopUpModal = true;
      this.openGenerateInvoice = false;
    },
    async shortListedspeakersBill() {
      const calBill = await this.calculateSpeakerBill();
      this.calculatedBill = !isNaN(Number(calBill)) ? calBill : 0;
      this.showLoadingScreen = false;
    },
    async syncShortlistedSpeaker(dealId) {
      this.loadingText = 'Syncing Speakers...';
      await syncShortlistedSpeaker(dealId);
    },
    async fetchShortlistedSpeaker(dealId) {
      this.loadingText = 'Fetching Speaker Data...';
      await fetchShortlistedSpeakers(dealId, this.dealInfo.function_date)
        .then(async (res) => {
          if (res.data) {
            const speakers = res.data;

            // Fetch related 'Shortlisted Speaker Fee' records for the opportunity.
            const feeRecordsResponse = await ZOHO.CRM.API.getRelatedRecords({
              Entity: 'Deals',
              RecordID: dealId,
              RelatedList: 'Shortlisted_Speaker_Fees',
            });
            const feeRecords = feeRecordsResponse.data || [];

            const speakersWithFees = [];

            // Attach fees to each active speaker.
            // Fees sit under their own property called 'fees'.
            speakers.forEach((speaker) => {
              // Find all fee records for the current Speaker.
              const speakerFeeRecords = feeRecords.filter((fee) => fee.Speaker.id === speaker.speaker.crm_id);
              if (speakerFeeRecords.length > 0)
              {
                // Add a new 'Speaker' to our list for each Fee record we have, since Speakers can appear multiple
                // times in the list if they have multiple fees.
                speakerFeeRecords.forEach((feeRecord) => {
                  // Shallow copy the speaker object to avoid mutating the original.
                  const newSpeaker = { ...speaker };
                  newSpeaker.fees = feeRecord;
                  speakersWithFees.push(newSpeaker);
                });
              }
              else
              {
                // Should never happen but handle just in case.
                console.log('No fees found for speaker: ', speaker);
                speaker.fees = null;
                speakersWithFees.push(speaker);
              }
            });

            // Separate the 'rejected' speakers into their own list.
            // Rejected speakers are not shown in the main list of speakers and are instead shown in a separate modal.
            this.rejectedSpeakers = speakersWithFees.filter((speaker) => speaker.fees && speaker.fees.Status === 'Rejected');
            const activeSpeakers = speakersWithFees.filter((speaker) => speaker.fees && speaker.fees.Status !== 'Rejected');

            // Update the speaker list with IDs of active speakers.
            this.speakerList = activeSpeakers.map((speaker) => speaker.speaker_id);

            // Separate booked and non-booked speakers.
            const bookedSpeakers = activeSpeakers.filter((speaker) => speaker.fees.Status === 'Booked');
            const nonBookedSpeakers = activeSpeakers.filter((speaker) => speaker.fees.Status !== 'Booked');

            // Combine booked and non-booked speakers into the main list.
            this.shortlistedSpeakerList = [...bookedSpeakers, ...nonBookedSpeakers];

            // Update the flag to check if any speaker is booked.
            this.isAnySpeakerBooked = bookedSpeakers.length > 0;
          }
        })
        .catch((err) => console.error(err));
    },
    async calculateSpeakerBill(){
      // Represents the total bill amount, which later gets used when generating an invoice.
      let billTotal = 0;

      // Stores shortlisted speakers' information. Gets used when generating an invoice.
      this.shortListedSpeakersInfo = [];

      // Stores all shortlisted speakers' information. Used later when calculating fees and commission.
      this.allShortlistedSpeakerInfo = [];

      // Stores shortlisted speakers' information. Gets used when generating a Purchase Order.
      this.allShortlistedPOInfo = [];

      // Define the fee types and their corresponding 'Allow' flags.
      const feeTypes = [
        { fee: 'Live_Keynote_Fee', allow: 'Allow_LKF_to_Qwilr' },
        { fee: 'In_Conversation_Fee', allow: 'Allow_ICF_to_Qwilr' },
        { fee: 'Virtual_Keynote_Fee', allow: 'Allow_VKFL_to_Qwilr' },
        { fee: 'Full_Day_Workshop_Fee', allow: 'Allow_FDWF_to_Qwilr' },
        { fee: 'Half_Day_Workshop_Fee', allow: 'Allow_HDWF_to_Qwilr' },
        { fee: 'MC_Half_Day_Fee', allow: 'Allow_MCHDF_to_Qwilr' },
        { fee: 'MC_Full_Day_Fee', allow: 'Allow_MCFDF_to_Qwilr' },
        { fee: 'Education_NFP_Fee', allow: 'Allow_ENF_to_Qwilr' },
        { fee: 'Campaign_Fee', allow: 'Allow_CF_to_Qwilr' },
        { fee: 'Other_Fee', allow: 'Allow_OF_to_Qwilr' },
      ];

      // Collect the 'Deals X Shortlisted' data for the current Opportunity too.
      // Some fields that get checked here don't sit on the 'Shortlisted Speaker
      // Fees' module.
      let dealsXShortlistedRecords = null;
      try {
        dealsXShortlistedRecords = await ZOHO.CRM.API.getRelatedRecords({
          Entity: 'Deals',
          RecordID: this.dealInfo.deal_id,
          RelatedList: 'Speakers5'
        });
      } catch (error)
      {
        console.error('Error fetching Deals X Shortlisted records: ', error);
        return 0;
      }

      this.shortlistedSpeakerList.forEach(speakerDetails => {
        // Declare fee totals that we want to track.
        // Keep at the Deals X Shortlisted level for now.
        speakerDetails.listprice = 0;
        speakerDetails.all_listprice = 0;

        // Helper function to calculate fees.
        const calculateFees = (feeType, allowFlag, includeInBill, updateAllListPrice = true) => {
          if (speakerDetails.fees[allowFlag]) {
            const feeAmount = Number(speakerDetails.fees[feeType]) || 0;
            if (updateAllListPrice) {
              speakerDetails.all_listprice += feeAmount;
            }
            if (includeInBill) {
              speakerDetails.listprice += feeAmount;
              billTotal += feeAmount;
            }
          }
        };

        // Get the matching Deals X Shortlisted record for the current speaker.
        let dealsXShortlistedRecord = null;
        if (dealsXShortlistedRecords && dealsXShortlistedRecords.data) {
          dealsXShortlistedRecord = dealsXShortlistedRecords.data.find(record => record.id === speakerDetails.shortlisted_speaker_crm_id);
        }

        const invoiceCreated = dealsXShortlistedRecord?.Invoice_Created;
        const poCreated = dealsXShortlistedRecord?.PO_Created;

        if (speakerDetails.fees.Status === 'Booked' && !invoiceCreated)
        {
          // Add each of our fees to the total for the speaker details.
          feeTypes.forEach(({ fee, allow }) => calculateFees(fee, allow, true));
          this.shortListedSpeakersInfo.push(speakerDetails);
          this.allShortlistedSpeakerInfo.push(speakerDetails);
        } else {
          // Calculate fees for all speakers, regardless of invoice status.
          feeTypes.forEach(({ fee, allow }) => calculateFees(fee, allow, false));
          this.allShortlistedSpeakerInfo.push(speakerDetails);
        }

        // If the speaker is 'Booked' and the invoice is created, but the Purchase Order is not created, 
        // calculate fees for Purchase Orders.
        if (speakerDetails.fees.Status === 'Booked' && invoiceCreated && !poCreated) {
          feeTypes.forEach(({ fee, allow }) => calculateFees(fee, allow, true, false));
          this.allShortlistedPOInfo.push(speakerDetails);
        }
      });

      return billTotal;
    },
    // Handles whether to show or hide the 'update' button next to each fee and 'Allow' checkbox fields.
    keyNoteValueChangeHandle(event, crmFieldApiName) {
      const inputElement = event.currentTarget;
      
      // Get the ID of the input element.
      // Note: crmFieldApiName can either be the API name of the checkbox OR the fee field.
      // If it represents the checkbox, the below value will be the fee field API name.
      // If it represents the fee field, the below value will be the checkbox API name.
      let correspondingFieldApiName = inputElement.id.split('-')[0];
     
      let shortlistedSpeakerFeesRecordId = inputElement.id.split('-')[1];

      let newValue = '';
      let oldValue = '';
      let relatedFieldValue = '';
      let relatedFieldOldValue = '';

      // If it includes 'Allow', it's a checkbox.
      if (correspondingFieldApiName.includes('Allow'))
      {
        // Get the old and new values of the checkbox.
        oldValue = this.getAllowedCheckboxVal(shortlistedSpeakerFeesRecordId, correspondingFieldApiName);
        newValue = event.target.checked;

        // Get the corresponding fee field's old and new values.
        const relatedFieldElement = document.querySelector('#' + crmFieldApiName + '-' + shortlistedSpeakerFeesRecordId);
        relatedFieldValue = relatedFieldElement.value;
        relatedFieldOldValue = this.getFeeAmount(shortlistedSpeakerFeesRecordId, crmFieldApiName);
      } else {
        // Get the old and new values of the fee field.
        oldValue = this.getFeeAmount(shortlistedSpeakerFeesRecordId, correspondingFieldApiName);
        newValue = event.target.value;

        // Get the corresponding checkbox's old and new values.
        const relatedFieldElement = document.querySelector('#' + crmFieldApiName + '-' + shortlistedSpeakerFeesRecordId);
        relatedFieldValue = relatedFieldElement.checked;
        relatedFieldOldValue = this.getAllowedCheckboxVal(shortlistedSpeakerFeesRecordId, crmFieldApiName);
      }
      
      // Get the 'update' button element associated with the relevant fields.
      const updateButton = document.querySelector('.' + correspondingFieldApiName + '-' + shortlistedSpeakerFeesRecordId);

      if (newValue == oldValue && relatedFieldValue == relatedFieldOldValue) {
        // Hide the 'update' button if the before and after values are the same (i.e. nothing has changed).
        updateButton.style.display = 'none';
      } else {
        // Display the 'update' button to the user if either of the values have been changed.
        updateButton.style.display = 'block';
      }
    },
    // Checks if the specified commission type (e.g., '%' or '$') exists for the given speaker.
    isCommissionType(shortlistedSpeakerFeesRecordId, commissionType) {

      let matchingSpeaker = this.shortlistedSpeakerList.filter(
        (speaker) => speaker.fees.id == shortlistedSpeakerFeesRecordId
      );

      if (matchingSpeaker.length > 0 && matchingSpeaker[0].fees.Commission != null) {
        return matchingSpeaker[0].fees.Commission.includes(commissionType);
      }

      return false;
    },
    // Displays the tick icon when the user changes the commission type.
    commissionTypeSelected(event, speaker) {
      const showTick = document.querySelector('.showTick-' + speaker.fees.id);
      showTick.style.display = 'block';
    },
    async selectOption(event, speaker) {
      let eventLogName = this.dealInfo.name+' ' + speaker.speaker.speaker_name  +' '+this.dealInfo.booking_number;
      if (eventLogName.length >= 255)
      {
        eventLogName = eventLogName.substring(0,eventLogName.length - 3);
      }
      let data = {
        status: event.target.value,
        shortlisted_speaker_crm_id: speaker.shortlisted_speaker_crm_id,
        opportunity_id: this.dealInfo.deal_id,
        eventLogisticName: eventLogName,
        speaker_crm_id: speaker.speaker.crm_id,
        speaker_id: speaker.id,
        event_start_date: null,
        event_end_date: null,
        addtional_dates: [],
        deal_name: this.dealInfo.name,
        function_date: this.dealInfo.function_date,
        shortlistedSpeakerFeesId: speaker.fees.id
      };

      if (event.target.value != speaker.fees.Status) {
        if (event.target.value == 'Held' || event.target.value == 'Booked') {
          // Prepopulate 'Additional Date' ranges in the 'Book Date Range' modal.
          this.additionalDates = [];
          this.dealInfo.additionalFunctionDatesSubform.forEach((subformRow) => {
            if (subformRow.Additional_Date != null)
            {
              // Convert string to a Date object. Force it to be at midnight.
              var additionalDate = new Date(subformRow.Additional_Date);

              // Add the 2 dates to our list to render in the calendar 
              // as a range correctly.
              var additionalDateRange = [];
              additionalDateRange.push(...[additionalDate, additionalDate]);

              this.additionalDates.push({'date_time':additionalDateRange});
            }
          });
          
          // Convert string to a Date object. Force it to be at midnight.
          var functionDate = this.dealInfo.function_date;
          var functionDateForRange = new Date(functionDate);

          // Add the 2 dates to our list to render in the calendar 
          // as a range correctly.
          var dateRange = [];
          dateRange.push(...[functionDateForRange, functionDateForRange]);

          this.eventDateTime = dateRange;

          this.showHeldPopUpModal = true;
          this.updateStatusData = data;
          this.isBookedPopUp = event.target.value == 'Booked' ? true : false;
        } else {
          this.loadingText = 'Updating Status...';
          this.loading = true;
          updateShortlistedSpeaker(speaker.id, data)
            .then(async (res) => {
              if (res) {
                speaker.fees.Status = event.target.value;

                if (event.target.value == 'Rejected')
                {
                  // Remove the speaker from the 'speakerList'.
                  // This prevents them from being passed in to the 'Search'
                  // functionality, which would falsely claim they are still
                  // 'active'. Not doing this will cause the 'Unassign' link
                  // to remain shown in the Search window even though they are
                  // no longer shown in the actual widget.
                  this.speakerList = this.speakerList.filter(
                    (speakerId) => speakerId != speaker.speaker_id
                  );

                  let removedSpeakerOrder = speaker.fees.Order;
                  let removedSpeakerCategory = speaker.fees.Category;
                  let shortlistedSpeakerFeesToUpdate = [];

                  // Adjust the Order of the remaining speakers in the same category.
                  this.shortlistedSpeakerList.forEach((existingSpeaker) => {
                    if (existingSpeaker.fees 
                      && existingSpeaker.fees.Category == removedSpeakerCategory
                      && existingSpeaker.fees.Order > removedSpeakerOrder) 
                    {
                      // Decrement the Order for speakers after the removed speaker.
                      existingSpeaker.fees.Order -= 1;
                      shortlistedSpeakerFeesToUpdate.push(existingSpeaker.fees);
                    }
                  });

                  // Update the order of all remaining speakers in the CRM.
                  await this.updateFeeRecordsInCrm(shortlistedSpeakerFeesToUpdate);

                  // Update the 'Rejected' record in the 'Shortlisted Speaker Fees' module.
                  await this.updateFeeRecordInCrm({
                    id: speaker.fees.id,
                    Category: null,
                    Order: null,
                    Status: 'Rejected',
                    Hold_Date: null,
                    Hold_End_Date: null
                  });

                  // Remove the speaker from the list.
                  this.shortlistedSpeakerList = this.shortlistedSpeakerList.filter(
                    (sp) => sp.id != speaker.id
                  );

                  // If the category that the speaker was in is now empty,
                  // remove it from the list of 'active' categories.
                  const categoryToRemove = speaker.fees.Category;
                  if (categoryToRemove) {
                    const speakersInCategory = this.shortlistedSpeakerList.filter(
                      (sp) => sp.fees.Category === categoryToRemove
                    );

                    // If no other speakers exist in the category, remove it from the order list.
                    if (speakersInCategory.length === 0) {
                      this.shortlistedSpeakerCategoriesOrder = this.shortlistedSpeakerCategoriesOrder.filter(
                        (category) => category !== categoryToRemove
                      );

                      // Optionally, update the Shortlisted Speaker Categories field in CRM.
                      const dealUpdateData = {
                        id: this.dealInfo.deal_id,
                        Shortlisted_Speaker_Categories: this.shortlistedSpeakerCategoriesOrder.join('|||'),
                      };
                      await this.updateDealRecordInCrm(dealUpdateData);
                    }
                  }

                  // Add the speaker to the rejected list.
                  // First remove their category and order.
                  speaker.fees.Category = null;
                  speaker.fees.Order = null;
                  this.rejectedSpeakers.push(speaker);

                  this.loading = false;
                  return;
                }

                // Update the status on the Shortlisted Speaker Fees record.
                await this.updateFeeRecordInCrm({
                  id: speaker.fees.id,
                  Status: event.target.value,
                  Hold_Date: null,
                  Hold_End_Date: null
                });

                this.loading = false;
              }
            })
            .catch((err) => console.error(err));
        }
      }
    },
    updateStatus() {
      if (this.eventDateTime != null) {
        this.showHeldPopUpModal = false;
        this.notDateFound = false;
        this.loadingText = 'Updating Status...';
        this.loading = true;
        this.updateStatusData['event_start_date'] = this.eventDateTime[0];
        this.updateStatusData['event_end_date'] = this.eventDateTime[1];
        this.updateStatusData['addtional_dates'] = this.additionalDates;
        // return false;
        updateShortlistedSpeaker(
          this.updateStatusData.speaker_id,
          this.updateStatusData
        )
          .then(async (res) => {
            if (res) {
              let status = document.querySelector(
                '.status-' + this.updateStatusData.shortlistedSpeakerFeesId
              );
              status.value = this.updateStatusData.status;

              let isoStartDate = null;
              let isoEndDate = null;

              if (this.updateStatusData.status == 'Held')
              {
                // Convert dates to Sydney timezone and ISO8601 for storing in the CRM.
                const eventStartDate = new Date(this.eventDateTime[0]);
                const eventEndDate = new Date(this.eventDateTime[1]);

                const eventStartDateSydney = new Date(
                  eventStartDate.toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
                );
                const eventEndDateSydney = new Date(
                  eventEndDate.toLocaleString('en-US', { timeZone: 'Australia/Sydney' })
                );

                isoStartDate = this.formatDateForCrm(eventStartDateSydney);
                isoEndDate = this.formatDateForCrm(eventEndDateSydney);
              }

              if (this.updateStatusData.status == 'Booked')
              {
                // Find the speaker in our list of shortlisted speakers.
                const speaker = this.shortlistedSpeakerList.find(
                  (speaker) => speaker.fees.id == this.updateStatusData.shortlistedSpeakerFeesId
                );

                // Set the speaker being booked to the top of the list for its Category.
                // Also set other fields like Status.
                speaker.fees.Order = 1;
                speaker.fees.Status = this.updateStatusData.status;

                await this.updateFeeRecordInCrm({
                  id: speaker.fees.id,
                  Category: speaker.fees.Category,
                  Order: speaker.fees.Order,
                  Status: speaker.fees.Status
                });

                // Find other speakers in the same category as the booked speaker.
                const otherSpeakersInCategory = this.shortlistedSpeakerList.filter(
                  (otherSpeaker) => 
                    otherSpeaker.fees.Category == speaker.fees.Category 
                    && otherSpeaker.fees.id != speaker.fees.id
                );

                // Shift the Order of the other speakers in the same category down by 1.
                for (let i = 0; i < otherSpeakersInCategory.length; i++) {
                  otherSpeakersInCategory[i].fees.Order += 1;
                }

                const speakersToUpdate = otherSpeakersInCategory.map((speaker) => ({
                  id: speaker.fees.id,
                  Category: speaker.fees.Category,
                  Order: speaker.fees.Order
                }));

                await this.updateFeeRecordsInCrm(speakersToUpdate);
              }
              else
              {
                // Update the status on the Shortlisted Speaker Fees record to Held.
                await this.updateFeeRecordInCrm({
                  id: this.updateStatusData.shortlistedSpeakerFeesId,
                  Status: this.updateStatusData.status,
                  Hold_Date: isoStartDate,
                  Hold_End_Date: isoEndDate
                });
              }

              await this.fetchShortlistedSpeaker(this.dealInfo.deal_id);

              this.loading = false;
            }
          })
          .catch((err) => console.error(err));
      } else {
        this.notDateFound = true;
      }
    },
    cancelUpdateStatus() {
      let status = document.querySelector(
        '.status-' + this.updateStatusData.shortlistedSpeakerFeesId
      );
      status.value = '';
      this.eventDateTime = null;
      this.additionalDates = [];
      this.showHeldPopUpModal = false;
      this.updateStatusData = {};
      this.notDateFound = false;
    },
    async generateFile(speaker) {
      this.showLoadingScreen = true;
      let opportunity_id = this.dealInfo.deal_id;
      let speaker_id = speaker.speaker.crm_id;
      let shortlistedSpId = speaker.shortlisted_speaker_crm_id;
      let arg = { opportunity_id: opportunity_id, speaker_id: speaker_id };

      let data = {
        file_generated: true,
      };

      try {
        // Attempts to generate the Mail Merge template for the client and speaker.
        const res = await generateFile(arg);
        if (res.data.status == 'success') {
          const update_res = await updateShortlistedSpeaker(
            shortlistedSpId,
            data
          );
          if (update_res) {
            this.showLoadingScreen = false;
            this.message =
              'Your document is being generated. Please refresh the window after few minutes to see the document in the attachments';
            this.showPopUpModal = true;
          }
        } else {
          this.showLoadingScreen = false;
          this.data.message = res.data.message;
          this.showPopUpModal = true;
        }
      } catch (err) {
        this.showLoadingScreen = false;
        this.showPopUpModal = true;
        this.message =
          'File is not generated sucessfully.Error Details: ' + err;
        console.error(err);
      }
    },
    changeColor(status) {
      let color;
      switch (status) {
        case 'Held':
          color = 'text-blue-500';
          break;
        case 'Booked':
          color = 'text-green-500';
          break;
        case 'Released':
          color = 'text-red-500';
          break;
        case 'Cancelled':
          color = 'text-orange-500';
          break;
        case 'Postponed':
          color = 'text-yellow-500';
          break;
        default:
          color = 'text-gray-200';
      }
      return color;
    },
    // Update the Commission value onto the CRM 'Shortlisted Speaker Fees' record.
    async updateCommission(shortlistedSpeakerFeesRecordId) {
      // Get the commission value for the particular row the user is updating.
      let commissionElement = document.getElementById('commission-' + shortlistedSpeakerFeesRecordId);
      // 'Percent' or 'Dollar'.
      let commissionTypeElement = document.getElementById('commission-type-' + shortlistedSpeakerFeesRecordId);
      let commissionType = commissionTypeElement.value;

      // Find the shortlisted speaker details for the row the user is updating.
      let shortlistedSpeakerDetails = this.allShortlistedSpeakerInfo.filter(
        (speaker) => speaker.fees.id == shortlistedSpeakerFeesRecordId
      );

      // Error handling.
      if (isNaN(commissionElement.value))
      {
        ElMessage({
          type: 'error',
          message: 'Only numbers are allowed.',
        });
        return false;
      }

      let newCommissionValue = '';
      let commissionDollar = 0;
      let commissionPercent = 0;
      let totalFees = shortlistedSpeakerDetails[0]?.all_listprice || 0;

      if (commissionType == '%')
      {
        // e.g. 50%
        newCommissionValue = commissionElement.value + commissionType;
        if (commissionElement.value > 100)
        {
          ElMessage({
            type: 'error',
            message: 'Percentage can not be more than 100',
          })
          return false;
        }

        // Calculate the other commission fields.
        commissionPercent = parseFloat(commissionElement.value);
        commissionDollar = (totalFees * commissionPercent) / 100;
      } else {
        // e.g. $50
        newCommissionValue = commissionType + commissionElement.value;

        // If the commission is in dollar amount, check if it's less than the total amount of fees.
        if (shortlistedSpeakerDetails.length > 0 && commissionElement.value > shortlistedSpeakerDetails[0].all_listprice) {
          ElMessage({
            type: 'error',
            message: 'Dollar amount should be less than total amount of Fees.',
          })
          return false;
        }

        // Calculate the other commission fields.
        commissionDollar = parseFloat(commissionElement.value);
        commissionPercent = (commissionDollar / totalFees) * 100;

         // Round the percentage (up to) 2 decimal places.
        commissionPercent = Math.round(commissionPercent * 100) / 100;
      }
    
      ElMessageBox.confirm(
        'Are you sure you want to update this commission?',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(async ()  => {

          var data = {
            // Update the new Commission value onto the CRM record.
            Entity: 'Shortlisted_Speaker_Fees',
            APIData: {
              id: shortlistedSpeakerFeesRecordId,
              Commission: newCommissionValue,
              Commission1: commissionDollar,
              Commission2: commissionPercent
            },
            Trigger: ['workflow'],
          };

          const updateRecordResponse = await ZOHO.CRM.API.updateRecord(data);
          if (updateRecordResponse) {

            // Update the commission locally as well.
            let matchingSpeaker = this.shortlistedSpeakerList.filter(
              (speaker) => speaker.fees.id == shortlistedSpeakerFeesRecordId
            );

            if (matchingSpeaker.length > 0)
            {
              matchingSpeaker[0].fees.Commission = newCommissionValue;
              matchingSpeaker[0].fees.Commission1 = commissionDollar;
              matchingSpeaker[0].fees.Commission2 = commissionPercent;
            }

            // Recalculate the bill amount since our commission has changed.
            this.shortListedspeakersBill();
            ElMessage({
              type: 'success',
              message: 'Commission updated Successfully!',
            })
          }        
        })
        .catch((error) => {
          // Reset the commission fields back to their original values.
          commissionElement.value = this.getCommissionAmount(shortlistedSpeakerFeesRecordId);

          let matchingSpeaker = this.shortlistedSpeakerList.filter(
            (speaker) => speaker.fees.id == shortlistedSpeakerFeesRecordId
          );

          if (matchingSpeaker.length > 0)
          {
            if (matchingSpeaker[0].fees.Commission.includes('$'))
            {
              commissionTypeElement.value = '$';
            }
            if (matchingSpeaker[0].fees.Commission.includes('%'))
            {
              commissionTypeElement.value = '%';
            }
          }
          ElMessage({
            type: 'info',
            message: 'Update canceled',
          });
        });
      
      // Hide the 'tick' icon after the user has updated the commission.
      const showTick = document.querySelector('.showTick-' + shortlistedSpeakerFeesRecordId);
      showTick.style.display = 'none';
    },
    showCommissionTick(event) {
      const inputElement = event.currentTarget;

      // Get the Fee record ID from the ID of the HTML element.
      let shortlistedSpeakerFeesRecordId = inputElement.id.split('-')[1];
      let commissionValue = event.target.value;
      let oldCommissionValue = this.getCommissionAmount(shortlistedSpeakerFeesRecordId);

      const showTick = document.querySelector('.showTick-' + shortlistedSpeakerFeesRecordId);

      // Display the 'tick' icon if the user has changed the commission value.
      if (commissionValue == oldCommissionValue) {
        showTick.style.display = 'none';
      } else {
        showTick.style.display = 'block';
      }
    },
    // Get the 'Commission' amount from the widget.
    getCommissionAmount(shortlistedSpeakerFeesRecordId) {
      let matchingSpeaker = this.shortlistedSpeakerList.filter(
        (speaker) => speaker.fees.id == shortlistedSpeakerFeesRecordId
      );

      if (matchingSpeaker.length > 0) {
        // Remove any special characters.
        let commissionAmount = (matchingSpeaker[0].fees.Commission != null) ? matchingSpeaker[0].fees.Commission.replace(/%|\$/gi,'').trim() : '';
        return commissionAmount;
      }

      return 0;
    },
    // Get the 'Fee' amount from the widget.
    getFeeAmount(shortlistedSpeakerFeesRecordId, feeFieldApiName) {
      // Find the fee data from the list of all shortlisted speakers.
      let speakerData = this.shortlistedSpeakerList.filter(
        (speaker) => speaker.fees.id == shortlistedSpeakerFeesRecordId
      );

      // If the speaker's data is found, return the 'Fee' amount.
      if (speakerData.length > 0)
      {
        return speakerData[0]?.fees?.[feeFieldApiName] || 0;
      }

      return 0;
    },
    // Update the 'Fee' and 'Allow' checkbox values from the widget onto the CRM records.
    async updateFeeAmount(shortlistedSpeakerFeesRecordId, feeFieldApiName, allowCheckboxFieldName) {
      // Get the 'fee input box' and 'checkbox' values.
      let feeFieldValue = document.querySelector('#' + feeFieldApiName + '-' + shortlistedSpeakerFeesRecordId);
      let allowCheckboxFieldValue = document.querySelector('#' + allowCheckboxFieldName + '-' + shortlistedSpeakerFeesRecordId);
      
      ElMessageBox.confirm(
        'Are you sure you want to update the fields?',
        {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(async ()  => {
          // Update the record with the new fee and 'Allow' checkbox value.
          var data = {
            Entity: 'Shortlisted_Speaker_Fees',
            APIData: {
              id: shortlistedSpeakerFeesRecordId
            },
            Trigger: ['workflow'],
          };
          
          data['APIData'][feeFieldApiName] = feeFieldValue.value;
          data['APIData'][allowCheckboxFieldName] = allowCheckboxFieldValue.checked;
 
          const updateRecordResponse = await ZOHO.CRM.API.updateRecord(data);
          if (updateRecordResponse) {
            // Recalculate the bill amount since our fee has changed.
            this.shortListedspeakersBill();
            ElMessage({
              type: 'success',
              message: 'Field updated successfully!',
            });

            // Need to set the fee locally in the 'shortlistedSpeakerList' list too.
            let matchingSpeaker = this.shortlistedSpeakerList.filter(
              (speaker) => speaker.fees.id == shortlistedSpeakerFeesRecordId
            );

            if (matchingSpeaker.length > 0)
            {
              matchingSpeaker[0].fees[feeFieldApiName] = feeFieldValue.value;
              matchingSpeaker[0].fees[allowCheckboxFieldName] = allowCheckboxFieldValue.checked;
            }
          }
        })
        .catch(() => {
          feeFieldValue.value = this.getFeeAmount(shortlistedSpeakerFeesRecordId, feeFieldApiName);
          allowCheckboxFieldValue.checked = this.getAllowedCheckboxVal(shortlistedSpeakerFeesRecordId, allowCheckboxFieldName);
          ElMessage({
            type: 'info',
            message: 'Update canceled',
          })
        })

        const buttonDiv = document.querySelector('.' + feeFieldApiName + '-' + shortlistedSpeakerFeesRecordId);
        buttonDiv.style.display = 'none';
    },
    // Get the 'Allow' checkbox value from the widget.
    getAllowedCheckboxVal(shortlistedSpeakerFeesRecordId, checkboxFieldApiName) {
      // Find the fee data from the list of all shortlisted speakers.
      let speakerData = this.shortlistedSpeakerList.filter(
        (speaker) => speaker.fees.id == shortlistedSpeakerFeesRecordId
      );

      // If the speaker's data is found, return the 'Allow' checkbox value.
      if (speakerData.length > 0)
      {
        return speakerData[0]?.fees?.[checkboxFieldApiName] || false;
      }

      return false;
    },
    adjustDays(date, days, operation) {
      var result = new Date(date);
      if (operation == 'Add') {
        result.setDate(result.getDate() + days);
      }

      if (operation == 'Subtract') {
        result.setDate(result.getDate() - days);
      }
      return result;
    },
    async onHover(speakerId) {
      this.speakerFeeData = {};
      const recordDetails = await ZOHO.CRM.API.getRecord({
        Entity: 'Speakers',
        RecordID: speakerId,
      });
      if (recordDetails.data) {
        let speakerDetails = recordDetails.data[0];
        this.speakerFeeData['Campaign_Fee'] = speakerDetails.Campaign_Fee;
        this.speakerFeeData['Live_Workshop_Fee'] = speakerDetails.Live_Workshop_Fee;
        this.speakerFeeData['Half_Day_Workshop_Fee'] = speakerDetails.Half_Day_Workshop_Fee;
        this.speakerFeeData['Live_Keynote_Fee'] = speakerDetails.Live_Keynote_Fee;
        this.speakerFeeData['In_Conversation_Fee'] = speakerDetails.In_Conversation_Fee;
        this.speakerFeeData['Other_Fee'] = speakerDetails.Other_Fee;
        this.speakerFeeData['Virtual_Keynote_Fee'] = speakerDetails.Virtual_Keynote_Livestream_Fee;
        this.speakerFeeData['MC_Rate'] = speakerDetails.MC_Rate;
        this.speakerFeeData['MC_Full_Day'] = speakerDetails.MC_Full_Day;
        this.speakerFeeData['Gross_Fees_Range'] = speakerDetails.Gross_Fees_Range;
        this.speakerFeeData['Education_NFP_Fee'] = speakerDetails.Education_NFP_Fee;
        this.speakerFeeData['City'] = speakerDetails.City;
      }
    },
    addMore() {
      this.additionalDates.push({'date_time':''});
    },
    async rejectAllSpeakers() {
      this.loading = true;
      this.loadingText = 'Rejecting all speakers, please wait...';

      try {
        for (const speaker of this.shortlistedSpeakerList) {

          // Remove the speaker from the 'speakerList'.
          // This prevents them from being passed in to the 'Search'
          // functionality, which would falsely claim they are still
          // 'active'. Not doing this will cause the 'Unassign' link
          // to remain shown in the Search window even though they are
          // no longer shown in the actual widget.
          this.speakerList = this.speakerList.filter(
            (sp) => sp.id != speaker.fees.id
          );
        }

        const feeRecordsToDelete = this.shortlistedSpeakerList.filter((speaker, index, self) => {
        // Finds a if this is not the first occurrence of the speaker's ID in the list.
          return self.findIndex((s) => s.speaker.id === speaker.speaker.id) !== index;
        });

        // Also update each speaker's fee record.
        let feeRecordsToUpdate = this.shortlistedSpeakerList
          .filter((speaker) => {
            // Exclude speakers whose fee records are in the feeRecordsToDelete list
            return !feeRecordsToDelete.some(
              (recordToDelete) => recordToDelete.fees.id === speaker.fees.id
            );
          })
          .map((speaker) => ({
            id: speaker.fees.id,
            Category: null,
            Order: null,
            Status: 'Rejected',
        }));

        if (feeRecordsToUpdate.length > 0)
        {
          await this.updateFeeRecordsInCrm(feeRecordsToUpdate);
        }

        if (feeRecordsToDelete.length > 0)
        {
          for (const record of feeRecordsToDelete) {
            await this.deleteShortlistedSpeakerFeeRecord(record.fees.id);
          }
        }
        
        this.removeEmptyCategories();

        // Update the 'Shortlisted Speaker Categories' field in the CRM and locally.
        this.shortlistedSpeakerCategoriesOrder = [];
        var dealUpdateData = {
          id: this.dealInfo.deal_id,
          Shortlisted_Speaker_Categories: null,
        };
        await this.updateDealRecordInCrm(dealUpdateData);

        // Refresh the list of shortlisted speakers.
        await this.fetchShortlistedSpeaker(this.dealInfo.deal_id);
        
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.showPopUpNotification('Failed to reject all speakers');
      }
    },
    // Fetch the list of shortlisted speaker categories that a Speaker can be assigned to in the widget.
    async fetchCategoriesGlobalPicklistFromCRM() {
      const connectionName = process.env.VUE_APP_CRM_GLOBAL_PICKLISTS_CONNECTION;
      const crmApiBaseUrl = process.env.VUE_APP_CRM_API_BASE_URL;
      const categoriesGlobalPicklistId = process.env.VUE_APP_CRM_CATEGORIES_GLOBAL_PICKLIST_ID;

      var requestData = {
        'method': 'GET',
        'url': `${crmApiBaseUrl}/settings/global_picklists/${categoriesGlobalPicklistId}`,
        // 1 = Parameters, 2 = Payload
        'param_type': 1
      };

      try {
        // Call the GET Global Picklist endpoint.
        var getGlobalPicklistResponse = await ZOHO.CRM.CONNECTION.invoke(connectionName, requestData);

        // Handle response.
        if (getGlobalPicklistResponse && getGlobalPicklistResponse.details && getGlobalPicklistResponse.details.statusMessage)
        {
          var globalPicklistsData = getGlobalPicklistResponse.details.statusMessage.global_picklists;
          if (globalPicklistsData && globalPicklistsData.length > 0)
          {
            const picklistValues = globalPicklistsData[0].pick_list_values;

            // Just get the name of each picklist option.
            this.shortlistedSpeakerCategories = picklistValues
            .map((item) => {
              if (item.display_value === '-None-') {
                // Replace dashes.
                return 'No Category';
              }
              return item.display_value;
            });

            // Also cross-check with our list of shortlisted speakers.
            // If a category doesn't exist in the picklist, add it to the list.
            // Users can add new categories when assigning a speaker.
            this.shortlistedSpeakerList.forEach((speaker) => {
              if (speaker.fees.Category !== null && !this.shortlistedSpeakerCategories.includes(speaker.fees.Category))
              {
                this.shortlistedSpeakerCategories.push(speaker.fees.Category);
              }
            });

            this.sortShortlistedSpeakerCategories();

            // Populate a list so that we always have the global picklist categories to access later.
            // Use the spread operator to create a shallow copy of the array.
            // This is important because we will be modifying the original array later.
            this.globalPicklistCategories = [...this.shortlistedSpeakerCategories];
          }
          else
          {
            console.error(`No picklists were found with the ID '${categoriesGlobalPicklistId}': `, getGlobalPicklistResponse);

            ElMessage({
              type: 'error',
              message: 'The list of categories could not be loaded from Zoho CRM. Please refresh the page and try again.',
            });
          }
        }
        else
        {
          console.error('Error fetching the categories global picklist: ', getGlobalPicklistResponse);
        }
      } catch (error) {
        console.error('Error fetching the categories global picklist: ', error);
      }
    },
    // Given an object of picklists, where the key is the API Name of the picklist for the given module,
    // returns the picklist values for each of the picklists from the CRM.
    async getPicklistValuesFromCRM(module, picklists) {
      const connectionName = process.env.VUE_APP_CRM_GLOBAL_PICKLISTS_CONNECTION;
      const crmApiBaseUrl = process.env.VUE_APP_CRM_API_BASE_URL;
      
      var requestData = {
        'method': 'GET',
        'url': `${crmApiBaseUrl}/settings/fields?module=${module}`,
        // 1 = Parameters, 2 = Payload
        'param_type': 1
      };

      try {
        // Call the GET Fields endpoint.
        var getFieldsResponse = await ZOHO.CRM.CONNECTION.invoke(connectionName, requestData);

        // Check for valid response.
        if (getFieldsResponse && getFieldsResponse.details && getFieldsResponse.details.statusMessage)
        {
          const fields = getFieldsResponse.details.statusMessage.fields;

          // Iterate through all fields on the module and find matches on API_Name.
          fields.forEach((field) => {
            if (picklists[field.api_name] && field.pick_list_values) {
              picklists[field.api_name] = field.pick_list_values
                .filter((value) => value.type === 'used')
                .filter((value) => value.display_value !== '-None-')
                .map((value) => value.display_value);
            }
          });
        } else {
          console.error('Error fetching the picklist values from the CRM: ', getFieldsResponse);
        }
      } catch (error) {
        console.error('Error fetching the picklist values from CRM: ', error);
      }
    },
    openEditCategoryModal(category) {
      this.categoryToUpdate = category;
      this.showEditCategoryModal = true;
    },
    closeEditCategoryModal() {
      this.showEditCategoryModal = false;
    },
    async saveEditedCategory(originalCategory, updatedCategory) {

      try {
        // Hide the Edit modal.
        this.showEditCategoryModal = false;

        // Display the 'Saving...' modal.
        this.saving = true;

        // Find the speakers to update the category against.
        const speakersToUpdate = this.shortlistedSpeakerList.filter(
          (speaker) => speaker.fees.Category == originalCategory
        );

        // Create list of Shortlisted Speaker Fee records to update.
        const shortlistedSpeakerFeesRecordsToUpdate = speakersToUpdate.map((speaker) => ({
          id: speaker.fees.id,
          Category: updatedCategory,
          Order: speaker.fees.Order
        }));

        await this.updateFeeRecordsInCrm(shortlistedSpeakerFeesRecordsToUpdate);

        // Update the categories locally as well.
        speakersToUpdate.forEach((speaker) => {
          speaker.fees.Category = updatedCategory;
        });

        // Replace the original category with the updated one in the categories order list.
        const categoryIndex = this.shortlistedSpeakerCategoriesOrder.indexOf(originalCategory);
        if (categoryIndex !== -1) {
          this.shortlistedSpeakerCategoriesOrder[categoryIndex] = updatedCategory;
        }

        // Save the updated categories order to the CRM.
        const dealUpdateData = {
          id: this.dealInfo.deal_id,
          Shortlisted_Speaker_Categories: this.shortlistedSpeakerCategoriesOrder.join('|||'),
        };
        await this.updateDealRecordInCrm(dealUpdateData);

        // Hide the modal now that we're done.
        this.saving = false;
      }
      catch (error) {
        console.error('Error updating the category: ', error);
        
        this.saving = false;
        this.showEditCategoryModal = true;
        
        ElMessage({
          type: 'error',
          message: 'There was an issue updating the Category for some of the Speakers. Please try again.',
        });
        
      }
    },
    // Helper function to split a list into batches of a given amount and return it.
    chunkArray(array, size) {
      const result = [];
      for (let i = 0; i < array.length; i += size) {
        result.push(array.slice(i, i + size));
      }
      return result;
    },
    // If a user adds a new category when assigning a Speaker, add it to our local list.
    addNewCategory(newCategory) {
      // Only add if category doesn't already exist.
      if (newCategory != null && !this.shortlistedSpeakerCategories.includes(newCategory))
      {
        this.shortlistedSpeakerCategories.push(newCategory);
      }

      this.sortShortlistedSpeakerCategories();
    },
    async rearrangeSpeakers(rearrangedSpeakers) {
      try {
        // Display the 'Saving...' modal.
        this.saving = true;

        // Flatten the array of speakers from the rearrange widget.
        const flattenedRearrangedSpeakers = Object.values(rearrangedSpeakers).flat();

        // For all rearranged speakers that are listed under 'No Category', replace with a null
        // value. We store Speakers without a category as null in the backend (CRM) and 'No Category' is 
        // merely just for display purposes for the end user. Do not save as 'No Category' in CRM.
        flattenedRearrangedSpeakers.forEach((speaker) => {
          if (speaker.fees.Category === 'No Category') {
            speaker.fees.Category = null;
          }
        });

        // First, confirm that no categories feature the same Speaker more than once.
        // If any duplicates found, alert the user and re-open the modal.
        const duplicateSpeakersInCategory = flattenedRearrangedSpeakers.filter((speaker, index, self) =>
          speaker.fees.Category !== 'No Category' &&
          // Check if the current speaker is a duplicate within the same category.
          // `findIndex` finds the first occurrence of a speaker with the same Category and ID.
          // If the current index is not the same as the first occurrence's index, it means this speaker is a duplicate.
          self.findIndex(
            (s) => s.fees.Category === speaker.fees.Category && s.speaker.id === speaker.speaker.id
          ) !== index
        );

        if (duplicateSpeakersInCategory.length > 0) {
          this.saving = false;

          ElMessage({
            type: 'error',
            message: 'A speaker can only exist once in any given category. Please check the list to remove any duplicates and try again.',
          });

          return;
        }

        // Group speakers by category.
        const groupedByCategory = flattenedRearrangedSpeakers.reduce((groups, speaker) => {
          const category = speaker.fees.Category || 'No Category';
          if (!groups[category]) {
            groups[category] = [];
          }
          groups[category].push(speaker);
          return groups;
        }, {});

        // Reorder speakers within each category.
        Object.keys(groupedByCategory).forEach((category) => {
          groupedByCategory[category].forEach((speaker, index) => {
            // Find the same speaker in the main list.
            const matchingSpeaker = this.shortlistedSpeakerList.find(
              (s) => s.fees.id === speaker.fees.id
            );

            if (matchingSpeaker) {
              // Update the category and order in the main list.
              matchingSpeaker.fees.Category = speaker.fees.Category;
              matchingSpeaker.fees.Order = index + 1;
            }
          });
        });

        // Update the local categories order.
        const newCategoriesOrder = Object.keys(rearrangedSpeakers);
        this.shortlistedSpeakerCategoriesOrder = newCategoriesOrder;

        // Save the new order of categories to the CRM also so the widget will load correctly next time.
        const dealUpdateData = {
          id: this.dealInfo.deal_id,
          Shortlisted_Speaker_Categories: newCategoriesOrder.join('|||'),
        };
        await this.updateDealRecordInCrm(dealUpdateData);

        // Create list of Shortlisted Speaker Fee records to update the Orders/Categories of.
        const shortlistedSpeakerFeesRecordsToUpdate = this.shortlistedSpeakerList.map((speaker) => ({
          id: speaker.fees.id,
          Category: speaker.fees.Category,
          Order: speaker.fees.Order
        }));

        await this.updateFeeRecordsInCrm(shortlistedSpeakerFeesRecordsToUpdate);

        // Remove any categories that no longer have any speakers in them.
        this.removeEmptyCategories();

        // Now that we're done, hide the modal.
        this.saving = false;
        this.openRearrangeSpeakersModal = false;
      }
      catch (error) {
        console.error('Error rearranging the speakers: ', error);
        
        this.saving = false;
        this.openRearrangeSpeakersModal = true;
        
        ElMessage({
          type: 'error',
          message: 'There was an issue rearranging some of the Speakers in CRM. Please try again. If you continue to see this message, please contact your Zoho partner.',
        });
      }
    },
    // Handles the addition of a new speaker to the shortlist.
    // Arguments:
    // deal: The deal/opportunity object, contains CRM data.
    // newSpeaker: The speaker being assigned as a new row. Data comes from backend.
    // newSpeakerCategory: The category of the new speaker.
    async handleNewSpeaker(deal, newSpeaker, newSpeakerCategory) {
      try {
        // Track the category in our widget in case it's a new one.
        this.addNewCategory(newSpeakerCategory);

        // If the speaker was previously rejected, we need to handle them slightly differently.
        let matchingRejectedSpeaker = this.rejectedSpeakers.find(
          (speaker) => speaker.speaker.crm_id === newSpeaker.crm_id
        );

        if (matchingRejectedSpeaker) {
          // Remove the speaker from the rejected list.
          this.rejectedSpeakers = this.rejectedSpeakers.filter(
            (speaker) => speaker.speaker.crm_id !== newSpeaker.crm_id
          );

          // Map the category to the previously rejected speaker.
          matchingRejectedSpeaker.fees.Category = newSpeakerCategory;

          // Get the speakers in the same category.
          const speakersInCategory = this.shortlistedSpeakerList.filter(
            (speaker) => speaker.fees.Category === newSpeakerCategory
          );

          // Assign the new speaker's Order as the next available Order in the category.
          if (speakersInCategory.length > 0) {
            matchingRejectedSpeaker.fees.Order = speakersInCategory.length + 1;
          }
          else {
            // If the category doesn't exist, add it to the beginning of the category list.
            matchingRejectedSpeaker.fees.Order = 1;

            // Add the new category to the shortlistedSpeakerCategoriesOrder list.
            if (!this.shortlistedSpeakerCategoriesOrder.includes(newSpeakerCategory)) {
              
              // Convert 'null' back to 'No Category' for display purposes (if applicable).
              const newCategoryToTrack = (newSpeakerCategory === null) ? 'No Category' : newSpeakerCategory;
              this.shortlistedSpeakerCategoriesOrder.push(newCategoryToTrack);

              // Update the categories order in the CRM.
              const dealUpdateData = {
                id: this.dealInfo.deal_id,
                Shortlisted_Speaker_Categories: this.shortlistedSpeakerCategoriesOrder.join('|||'),
              };
              await this.updateDealRecordInCrm(dealUpdateData);
            }
          }

          // Update the category and order in the CRM. Also remove the 'Rejected' status.
          await this.updateFeeRecordInCrm({
            id: matchingRejectedSpeaker.fees.id,
            Category: newSpeakerCategory,
            Order: matchingRejectedSpeaker.fees.Order,
            Status: null
          });

          // Add the speaker to the shortlisted list.
          this.shortlistedSpeakerList.push(matchingRejectedSpeaker);

          return;
        }

        // If we reach here, we are creating a new speaker that was not previously rejected.
        let shortlistedSpeakerFeesRecordToCreate = {
          Currency: deal.currency,
          Opportunity: deal.deal_id,
          Speaker: newSpeaker.crm_id,
          Category: newSpeakerCategory
        };

        // Check if the category for the new speaker already exists in the widget.
        const speakersInCategory = this.shortlistedSpeakerList.filter(
          (speaker) => speaker.fees.Category === newSpeakerCategory
        );

        if (speakersInCategory.length > 0)
        {
          // If the category already exists, add onto the end of the category. 
          shortlistedSpeakerFeesRecordToCreate.Order = speakersInCategory.length + 1;
        }
        else
        {
          // If the category doesn't exist, add it to the beginning of the category list.
          shortlistedSpeakerFeesRecordToCreate.Order = 1;
         
          // Convert 'null' back to 'No Category' for display purposes (if applicable).
          const newCategoryToTrack = (newSpeakerCategory === null) ? 'No Category' : newSpeakerCategory;

           // Add the new category to the category order list. Add to the end by default.
          this.shortlistedSpeakerCategoriesOrder.push(newCategoryToTrack);

          // Update the categories order in the CRM.
          const dealUpdateData = {
            id: this.dealInfo.deal_id,
            Shortlisted_Speaker_Categories: this.shortlistedSpeakerCategoriesOrder.join('|||'),
          };
          await this.updateDealRecordInCrm(dealUpdateData);
        }

        // Create the newSpeaker in the Shortlisted Speaker Fees module.
        const createFeeRecordResponse = await ZOHO.CRM.API.insertRecord({
          Entity: 'Shortlisted_Speaker_Fees',
          APIData: shortlistedSpeakerFeesRecordToCreate,
          Trigger: ['workflow'],
        });

        // Handle the create fee response.
        if (!createFeeRecordResponse || createFeeRecordResponse.data[0].code !== 'SUCCESS') {
          console.error('Error creating the new Shortlisted Speaker Fee record: ', createFeeRecordResponse);

          ElMessage({
            type: 'error',
            message: 'Failed to create the new Shortlisted Speaker Fee record. Please try again.',
          });

          return;
        }
      }
      catch (error)
      {
        console.error('Error updating Fee records:', error);

        ElMessage({
          type: 'error',
          message: 'Failed to update Fee records. Please try again. If the issue persists, contact your Zoho partner.',
        });
      }
    },
    async updateDealRecordInCrm(dealRecord)
    {
      try {
        const connectionName = process.env.VUE_APP_CRM_DEFAULT_CONNECTION;
        const crmApiBaseUrl = process.env.VUE_APP_CRM_API_BASE_URL;

        var data = {
          Entity: 'Deals',
          APIData: dealRecord,
          Trigger: ['workflow']
        };

        // Update the record in CRM.
        const updateRecordResponse = await ZOHO.CRM.API.updateRecord(data);

        if (!updateRecordResponse || updateRecordResponse.data[0].code !== 'SUCCESS') {
          console.error('Error updating the Deal record: ', updateRecordResponse);

          ElMessage({
            type: 'error',
            message: 'Failed to update the Deal record. Please try again.',
          });
        }
      } catch (error) {
        console.error('Error updating the Deal record:', error);
        ElMessage({
          type: 'error',
          message: 'There was an issue updating the Deal record in CRM. Please try again.',
        }); 
      }
    },
    // Update a single Fee record in the CRM.
    async updateFeeRecordInCrm(feeRecord) {
      try {
        const connectionName = process.env.VUE_APP_CRM_DEFAULT_CONNECTION;
        const crmApiBaseUrl = process.env.VUE_APP_CRM_API_BASE_URL;

        var data = {
          Entity: 'Shortlisted_Speaker_Fees',
          APIData: feeRecord,
          Trigger: ['workflow']
        };

        // Update the record in CRM.
        const updateRecordResponse = await ZOHO.CRM.API.updateRecord(data);

        if (!updateRecordResponse || updateRecordResponse.data[0].code !== 'SUCCESS') {
          console.error('Error updating the Fee record: ', updateRecordResponse);

          ElMessage({
            type: 'error',
            message: 'Failed to update the Fee record. Please try again.',
          });
        }
      } catch (error) {
        console.error('Error updating the Fee record:', error);
        ElMessage({
          type: 'error',
          message: 'There was an issue updating the Fee record in CRM. Please try again.',
        }); 
      }
    },
    async updateFeeRecordsInCrm(feeRecords) {
      const connectionName = process.env.VUE_APP_CRM_DEFAULT_CONNECTION;
      const crmApiBaseUrl = process.env.VUE_APP_CRM_API_BASE_URL;

      // Prepare the fee records for the API update.
      const recordsToUpdate = feeRecords.map((fee) => ({
        id: fee.id,
        Category: fee.Category,
        Order: fee.Order,
        Status: fee.Status,
      }));

      // Chunk the updates into batches of 100 (CRM API limit).
      const feeBatches = this.chunkArray(recordsToUpdate, 100);

      for (let batch of feeBatches) {
        const requestData = {
          parameters: {
            data: batch,
          },
          method: 'PUT',
          url: `${crmApiBaseUrl}/Shortlisted_Speaker_Fees`,
          // 1 = Parameters, 2 = Payload
          param_type: 2,
        };

        const response = await ZOHO.CRM.CONNECTION.invoke(connectionName, requestData);

        if (!response || !response.details || !response.details.statusMessage) {
          throw new Error('Failed to update Fee records in CRM');
        }

        const updateResults = response.details.statusMessage.data;
        const failedUpdates = updateResults.filter((result) => result.code !== 'SUCCESS');

        if (failedUpdates.length > 0) {
          console.error('Failed to update some Fee records:', failedUpdates);
          throw new Error('Some Fee records failed to update in CRM');
        }
      }
    },
    showRemoveSpeakerModal(speakerToRemove) {
      this.speakerToRemove = speakerToRemove;
      this.openRemoveSpeakerModal = true;
    },
    async removeSpeakerRow(speakerToRemove) {
      try {
        // Close the Remove Speaker modal.
        this.openRemoveSpeakerModal = false;

        // Display the 'Saving...' modal.
        this.saving = true;

        // Find all Speakers rows we have in the widget.
        var matchingSpeakers = this.shortlistedSpeakerList.filter(
          (speaker) => speaker.speaker.crm_id == speakerToRemove.speaker.crm_id
        );

        if (matchingSpeakers.length == 1)
        {
          // If we find 1 match, meaning the Speaker only appears once in the widget,
          // run the full 'Unassign' logic to remove their Deals X Shortlisted and
          // database records.
          let unassignData = {
            deal: this.dealInfo,
            speaker: speakerToRemove.speaker
          };

          // Unassign the Speaker in the backend.
          await noAssignSpeaker(unassignData);

          // Delete the Shortlisted Speaker Fee record too.
          await this.deleteShortlistedSpeakerFeeRecord(speakerToRemove.fees.id);

          // Remove the Speaker from the local list.
          this.shortlistedSpeakerList = this.shortlistedSpeakerList.filter(
            (speaker) => speaker.speaker.crm_id != speakerToRemove.speaker.crm_id
          );

          // Update the order of all Speakers since we have removed one.
          await this.reorderSpeakers();

          this.removeEmptyCategories();

          // Also remove the Speaker's category from the categories order list, but only if
          // there are no other speakers in that category.
          const categoryToRemove = speakerToRemove.fees.Category;
          if (categoryToRemove) {
            const speakersInCategory = this.shortlistedSpeakerList.filter(
              (speaker) => speaker.fees.Category === categoryToRemove
            );

            // If no other speakers exist in the category, remove it from the order list.
            if (speakersInCategory.length === 0) {
              this.shortlistedSpeakerCategoriesOrder = this.shortlistedSpeakerCategoriesOrder.filter(
                (category) => category !== categoryToRemove
              );

              // Update the Shortlisted Speaker Categories field in the CRM.
              const dealUpdateData = {
                id: this.dealInfo.deal_id,
                Shortlisted_Speaker_Categories: this.shortlistedSpeakerCategoriesOrder.join('|||'),
              };
              await this.updateDealRecordInCrm(dealUpdateData);
            }
          }

          // Refresh the widget data.
          this.fetchShortlistedSpeaker(this.dealInfo.deal_id);
        }
        else if (matchingSpeakers.length > 1)
        {
          // If we find more than 1 match, we only want to remove the one Shortlisted
          // Speaker Fee record, and leave the other rows and the Deals X Shortlisted
          // record intact.
          await this.deleteShortlistedSpeakerFeeRecord(speakerToRemove.fees.id);

          // Remove the Speaker's fee row from the local list.
          this.shortlistedSpeakerList = this.shortlistedSpeakerList.filter(
            (speaker) => speaker.fees.id != speakerToRemove.fees.id
          );

          // Update the order of all Speakers since we have removed one.
          await this.reorderSpeakers();

          // Refresh the widget data.
          this.fetchShortlistedSpeaker(this.dealInfo.deal_id);
        }

        this.saving = false;
      } catch (error) {
        console.error('Error removing the speaker row: ', error);
        
        this.saving = false;
        this.openRemoveSpeakerModal = true;
        
        ElMessage({
          type: 'error',
          message: 'There was an issue removing the Speaker row in CRM. Please try again. If you continue to see this message, please contact your Zoho partner.',
        });
      }
    },
    async reorderSpeakers() {
      try {
        let updateRequired = false;

        // Group speakers by category.
        const groupedByCategory = this.shortlistedSpeakerList.reduce((groups, speaker) => {
          const category = speaker.fees.Category || 'No Category';
          if (!groups[category]) {
            groups[category] = [];
          }
          groups[category].push(speaker);
          return groups;
        }, {});

        // Reorder speakers within each category.
        Object.keys(groupedByCategory).forEach((category) => {
          let currentOrder = 1;

          groupedByCategory[category]
            .sort((a, b) => (a.fees.Order || 0) - (b.fees.Order || 0))
            .forEach((speaker) => {
              const originalOrder = speaker.fees.Order;
              speaker.fees.Order = currentOrder;
              currentOrder += 1;

              if (originalOrder !== speaker.fees.Order) {
                updateRequired = true;
              }
          });
        });

        if (updateRequired) {
          // Prepare to update the Fee records in CRM.
          const feeRecordsToUpdate = this.shortlistedSpeakerList.map((speaker) => ({
            id: speaker.fees.id,
            Category: speaker.fees.Category,
            Order: speaker.fees.Order,
          }));

          await this.updateFeeRecordsInCrm(feeRecordsToUpdate);
        }
      } catch (error) {
        console.error('Error reordering speakers: ', error);

        ElMessage({
          type: 'error',
          message: 'There was an issue reordering the Speakers in CRM. Please try again. If you continue to see this message, please contact your Zoho partner.',
        });
      }
    },
    // Deletes all Shortlisted Speaker Fee records for a given Speaker.
    async deleteShortlistedSpeakerFeeRecordsForSpeaker(dealId, speakerId) {
      try {
        // Get the list of Shortlisted Speaker Fee records for the given Opportunity and Speaker.
        const feeRecordsResponse = await ZOHO.CRM.API.getRelatedRecords({
          Entity: 'Deals',
          RecordID: dealId,
          RelatedList: 'Shortlisted_Speaker_Fees',
        });

        if (feeRecordsResponse && feeRecordsResponse.data && feeRecordsResponse.data.length > 0) {
          const feeRecordsToDelete = feeRecordsResponse.data.filter((record) => record.Speaker.id == speakerId);

          for (const record of feeRecordsToDelete) {
            await this.deleteShortlistedSpeakerFeeRecord(record.id);
          }
        }

        // Remove the Speaker from the local list.
        this.shortlistedSpeakerList = this.shortlistedSpeakerList.filter((speaker) => speaker.speaker.crm_id != speakerId);

        // In case this speaker was the only one in any particular category, remove any now empty categories.
        const updatedShortlistedSpeakerCategoriesOrder = this.shortlistedSpeakerCategoriesOrder.filter((category) => {
          return this.shortlistedSpeakerList.some(
            (speaker) => speaker.fees.Category === category);
        });

        if (updatedShortlistedSpeakerCategoriesOrder.length !== this.shortlistedSpeakerCategoriesOrder.length) {
          // Only update the categories order list if it has changed.
          this.shortlistedSpeakerCategoriesOrder = updatedShortlistedSpeakerCategoriesOrder;

          // Update the Shortlisted Speaker Categories field in the CRM.
          const dealUpdateData = {
            id: dealId,
            Shortlisted_Speaker_Categories: this.shortlistedSpeakerCategoriesOrder.join('|||'),
          };
          await this.updateDealRecordInCrm(dealUpdateData);
        }        
      } catch (error) {
        console.error('Error deleting Shortlisted Speaker Fee records: ', error);

        ElMessage({
          type: 'error',
          message: 'There was an issue deleting the Shortlisted Speaker Fee records in CRM. Please try again. If you continue to see this message, please contact your Zoho partner.',
        });
      }
    },
    // Deletes a single Shortlisted Speaker Fees record, based on the given record ID.
    async deleteShortlistedSpeakerFeeRecord(shortlistedSpeakerFeeRecordId) {
      try {
        await ZOHO.CRM.API.deleteRecord({
          Entity: 'Shortlisted_Speaker_Fees',
          RecordID: shortlistedSpeakerFeeRecordId
        });
      } catch (error) {
        console.error('Error deleting the Shortlisted Speaker Fee record: ', error);

        ElMessage({
          type: 'error',
          message: 'There was an issue deleting the Shortlisted Speaker Fee record in CRM. Please try again. If you continue to see this message, please contact your Zoho partner.',
        });
      }
    },
    removeEmptyCategories() {
      // Create a Set of categories that should always exist.
      const alwaysIncludedCategories = new Set([...this.globalPicklistCategories, 'No Category']);

      // Filter the categories to remove empty ones, except for those in the alwaysIncludedCategories set.
      this.shortlistedSpeakerCategories = this.shortlistedSpeakerCategories.filter((category) => {
        // Keep the category if it's in the alwaysIncludedCategories set.
        if (alwaysIncludedCategories.has(category)) {
          return true;
        }

        // Otherwise, check if the category has any speakers assigned to it.
        const speakersInCategory = this.speakersGroupedByCategory[category];
        return speakersInCategory && speakersInCategory.length > 0;
      });

      this.sortShortlistedSpeakerCategories();
    },
    sortShortlistedSpeakerListByOrder() {
      // Sort the shortlisted speakers list by the Order field.
      this.shortlistedSpeakerList.sort((a, b) => (a.fees.Order || 0) - (b.fees.Order || 0));
    },
    // Outputs a date in the format YYYY-MM-DDTHH:MM:SS+HH:MM
    formatDateForCrm(date)
    {
      const pad = (num) => String(num).padStart(2, '0');

      const year = date.getFullYear();
      const month = pad(date.getMonth() + 1); // Months are 0-based
      const day = pad(date.getDate());
      const hours = pad(date.getHours());
      const minutes = pad(date.getMinutes());
      const seconds = pad(date.getSeconds());

      // Get timezone offset in hours and minutes
      const offset = date.getTimezoneOffset(); // Offset in minutes
      const offsetHours = pad(Math.abs(Math.floor(offset / 60)));
      const offsetMinutes = pad(Math.abs(offset % 60));
      const offsetSign = offset > 0 ? '-' : '+';

      return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}${offsetSign}${offsetHours}:${offsetMinutes}`;
    },
    // Re-sort the shortlisted speaker categories alphabetically, keeping 'No Category' at the top.
    sortShortlistedSpeakerCategories() {
      this.shortlistedSpeakerCategories.sort((a, b) => {
        if (a === 'No Category') return -1;
        if (b === 'No Category') return 1;
        return a.localeCompare(b);
      });
    },
  }
};
</script>

<style scoped>

  #shortlisted-speakers-table-head {
    position: sticky;
    top: -1px;
    opacity: 1;
    z-index: 2;
  }

  .z-1 {
    z-index: 1;
  }

  .bg-inherit {
    background-color: inherit;
  }

</style>
